// src/pages/administrativo/ConfigModuloSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useConfigModulo } from '../../contexts/administrativo/ConfigModuloContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const ConfigModuloSearch = ({ show, onHide, onSelectConfigModulo }) => {
    const { configModuloList } = useConfigModulo();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');

            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    }, [show]);

    if (!show) return null;

    const filteredConfigModulo = configModuloList.filter(config =>
        config.filialId.toString().includes(filter.toLowerCase())
    );

    const sortedConfigModulo = filteredConfigModulo.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'nomeEstabelecimento') {
            const nomeA = a.nomeEstabelecimento.toString().toLowerCase();
            const nomeB = b.nomeEstabelecimento.toString().toLowerCase();
            if (nomeA < nomeB) return sortDirection === 'asc' ? -1 : 1;
            if (nomeA > nomeB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        } else if (sortField === 'filialId') {
            const filialA = a.filialId.toString().toLowerCase();
            const filialB = b.filialId.toString().toLowerCase();
            if (filialA < filialB) return sortDirection === 'asc' ? -1 : 1;
            if (filialA > filialB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (configModulo) => {
        onSelectConfigModulo(configModulo);
        onHide();
    };

    return (
        <ModalContainer show={show} largura="600px" variant="busca" onHide={onHide}>

            <ModalHeader title="Buscar Configuração de Módulo" onHide={onHide} />
            <ModalBody className="modal-body">
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por filial..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedConfigModulo} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable  containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="align-middle" scope="col" style={{ width: '50%' }} aria-sort={sortField === 'nomeEstabelecimento' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('nomeEstabelecimento')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} type="button">
                                    Nome Estabelecimento
                                    {sortField === 'nomeEstabelecimento' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'filialId' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('filialId')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} type="button">
                                    Filial
                                    {sortField === 'filialId' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(configModulo => (
                            <tr key={configModulo.id} onDoubleClick={() => handleDoubleClick(configModulo)}>
                                <td className="text-end align-middle">{configModulo?.id}</td>
                                <td className="align-middle">{configModulo?.nomeEstabelecimento}</td>
                                <td className="align-middle">{configModulo?.filialId}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectConfigModulo(configModulo)} label={configModulo?.nomeEstabelecimento} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter className="modal-footer">

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>

        </ModalContainer>
    );
};

export default ConfigModuloSearch;
